import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
const privacyContent = <div className="space-y-4" data-id="element-53">
    <h2 className="font-serif text-2xl text-brand-light mb-4" data-id="element-54">
      Política de Privacidad
    </h2>
    <p className="text-brand-light/70 text-sm leading-relaxed" data-id="element-55">
      Última actualización:{' '}
      {new Date().toLocaleDateString('es-ES', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    })}
    </p>

    <h3 className="text-lg font-medium text-brand-light mt-6" data-id="element-56">
      1. Información que Recopilamos
    </h3>
    <p className="text-brand-light/70 leading-relaxed" data-id="element-57">
      Recopilamos únicamente la información necesaria para procesar tu compra:
      nombre, dirección de correo electrónico y datos de pago. No almacenamos
      datos de tarjetas de crédito directamente; estos son procesados por
      nuestro proveedor de pagos seguro.
    </p>

    <h3 className="text-lg font-medium text-brand-light mt-6" data-id="element-58">
      2. Uso de la Información
    </h3>
    <p className="text-brand-light/70 leading-relaxed" data-id="element-59">
      Tu información se utiliza exclusivamente para: entregar el producto
      digital adquirido, enviar confirmaciones de compra y, si lo autorizas,
      enviarte contenido relacionado. Nunca vendemos ni compartimos tus datos
      con terceros.
    </p>

    <h3 className="text-lg font-medium text-brand-light mt-6" data-id="element-60">
      3. Protección de Datos
    </h3>
    <p className="text-brand-light/70 leading-relaxed" data-id="element-61">
      Implementamos medidas de seguridad estándar de la industria para proteger
      tu información personal. Todas las transacciones se realizan a través de
      conexiones cifradas (SSL).
    </p>

    <h3 className="text-lg font-medium text-brand-light mt-6" data-id="element-62">4. Cookies</h3>
    <p className="text-brand-light/70 leading-relaxed" data-id="element-63">
      Utilizamos cookies esenciales para el funcionamiento del sitio y cookies
      analíticas para mejorar tu experiencia. Puedes desactivar las cookies en
      la configuración de tu navegador.
    </p>

    <h3 className="text-lg font-medium text-brand-light mt-6" data-id="element-64">
      5. Tus Derechos
    </h3>
    <p className="text-brand-light/70 leading-relaxed" data-id="element-65">
      Tienes derecho a acceder, rectificar o eliminar tus datos personales en
      cualquier momento. Para ejercer estos derechos, puedes contactarnos a
      través de los canales disponibles en nuestro sitio.
    </p>
  </div>;
const termsContent = <div className="space-y-4" data-id="element-66">
    <h2 className="font-serif text-2xl text-brand-light mb-4" data-id="element-67">
      Términos y Condiciones
    </h2>
    <p className="text-brand-light/70 text-sm leading-relaxed" data-id="element-68">
      Última actualización:{' '}
      {new Date().toLocaleDateString('es-ES', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    })}
    </p>

    <h3 className="text-lg font-medium text-brand-light mt-6" data-id="element-69">
      1. Producto Digital
    </h3>
    <p className="text-brand-light/70 leading-relaxed" data-id="element-70">
      "Más Que Padres" es un producto digital educativo e informativo. El acceso
      se otorga de forma inmediata tras la confirmación del pago. Este material
      no sustituye el consejo de terapeutas de pareja, médicos o especialistas
      en salud mental.
    </p>

    <h3 className="text-lg font-medium text-brand-light mt-6" data-id="element-71">
      2. Licencia de Uso
    </h3>
    <p className="text-brand-light/70 leading-relaxed" data-id="element-72">
      Al adquirir la guía, obtienes una licencia personal e intransferible.
      Queda prohibida la reproducción, distribución o reventa del contenido sin
      autorización expresa.
    </p>

    <h3 className="text-lg font-medium text-brand-light mt-6" data-id="element-73">
      3. Política de Reembolso
    </h3>
    <p className="text-brand-light/70 leading-relaxed" data-id="element-74">
      Debido a la naturaleza digital del producto, no se ofrecen reembolsos una
      vez entregado el acceso. Si experimentas problemas técnicos para acceder
      al contenido, te ayudaremos a resolverlos.
    </p>

    <h3 className="text-lg font-medium text-brand-light mt-6" data-id="element-75">4. Resultados</h3>
    <p className="text-brand-light/70 leading-relaxed" data-id="element-76">
      Los resultados mencionados en esta página son orientativos y pueden variar
      según cada pareja. Cada relación es única y los resultados dependen del
      compromiso mutuo de ambas partes.
    </p>

    <h3 className="text-lg font-medium text-brand-light mt-6" data-id="element-77">
      5. Modificaciones
    </h3>
    <p className="text-brand-light/70 leading-relaxed" data-id="element-78">
      Nos reservamos el derecho de modificar estos términos en cualquier
      momento. Las modificaciones serán efectivas desde su publicación en esta
      página.
    </p>
  </div>;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="py-8 text-center text-brand-light/30 text-sm font-light border-t border-brand-light/5" data-id="element-79">
        <p className="mb-3" data-id="element-80">
          © {new Date().getFullYear()} Más Que Padres. Todos los derechos
          reservados.
        </p>
        <div className="flex items-center justify-center gap-4" data-id="element-81">
          <button onClick={() => setActiveModal('privacy')} className="hover:text-brand-light/60 transition-colors underline underline-offset-2" data-id="element-82">
            Política de Privacidad
          </button>
          <span className="text-brand-light/15" data-id="element-83">|</span>
          <button onClick={() => setActiveModal('terms')} className="hover:text-brand-light/60 transition-colors underline underline-offset-2" data-id="element-84">
            Términos y Condiciones
          </button>
        </div>
      </footer>

      <AnimatePresence data-id="element-85">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-86">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.3
        }} className="relative bg-brand-dark border border-brand-light/10 rounded-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto p-8" onClick={e => e.stopPropagation()} data-id="element-87">
              <button onClick={() => setActiveModal(null)} className="absolute top-4 right-4 text-brand-light/40 hover:text-brand-light transition-colors" data-id="element-88">
                <XIcon className="w-5 h-5" data-id="element-89" />
              </button>

              {activeModal === 'privacy' ? privacyContent : termsContent}
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}